import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { SalesOrderOutline } from '@/hooks/api/models';
import { useMemo } from 'react';
import { SalesOrderOutlineLogic } from '@/hooks/api/models/logics';
import { useNextSalesOrders } from '@/hooks/api/1263_next_sales_orders';

export const NextSalesOrdersElement = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const orderParams = { identifier: _w_!.identifier, team_id: _t_!.id, id: _so_!.id };
  const { data: nextOrders } = useNextSalesOrders(orderParams);

  if (nextOrders == null || nextOrders.length === 0) return null;

  return (
    <>
      <hr className="horizontal dark my-3" />

      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">以降のプロジェクト</th>
            </tr>
          </thead>
          <tbody>{nextOrders?.map((d) => <NextSalesOrderRow key={`next-order-${d.id}`} d={d} />)}</tbody>
        </table>
      </div>
    </>
  );
};

type Props = {
  d: SalesOrderOutline;
};
const NextSalesOrderRow = ({ d }: Props) => {
  const orderLabel = useMemo(() => {
    return SalesOrderOutlineLogic.toLabel(d);
  }, [d]);

  return (
    <tr>
      <td className="font-weight-bold text-sm text-dark mb-1">{orderLabel}</td>
    </tr>
  );
};
